import { ToggleButton, ToggleButtonGroup, type ToggleButtonProps } from "@mui/material";
import { darken, styled } from "@mui/material/styles";

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  height: 32,
  boxShadow: `0px 1px 3px 0px ${theme.palette.boxShadow.dark}, 0px 2px 2px 0px ${theme.palette.boxShadow.light}, 0px 0px 2px 0px ${theme.palette.boxShadow.main}`,
  border: "unset",
  borderTopLeftRadius: 8,
  borderBottomLeftRadius: 8,
  borderTopRightRadius: 8,
  borderBottomRightRadius: 8,
}));

interface IStyledToggleButtonProps extends ToggleButtonProps {
  selectedColor: string;
}

export const StyledToggleButton = styled(ToggleButton, {
  shouldForwardProp: (prop) => prop !== "themeColor",
})<IStyledToggleButtonProps>(({ theme, selectedColor }) => {
  const darkerColor = darken(selectedColor, 0.1);
  return {
    display: "flex",
    boxShadow: "unset",
    jusitfyContent: "center",
    gap: theme.spacing(0.5),
    textTransform: "none",
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,

    "&:first-of-type": {
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
    },
    "&:last-of-type": {
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8,
    },

    [theme.breakpoints.down("tablet")]: {
      "& .MuiTypography-root": {
        display: "none",
      },
    },

    "&.Mui-selected": {
      backgroundColor: selectedColor,
      border: `1px solid ${selectedColor}`,
      borderLeft: `1px solid ${theme.palette.primary.main}`,
      borderRight: `1px solid ${theme.palette.primary.main}`,
      color: theme.palette.common.white,
      "&:hover": {
        borderTop: `1px solid ${darkerColor}`,
        borderBottom: `1px solid ${darkerColor}`,
        backgroundColor: darkerColor,
        color: theme.palette.common.white,
      },
      "&:first-of-type": {
        borderLeft: `1px solid ${darkerColor}`,
      },
      "&:last-of-type": {
        borderRight: `1px solid ${darkerColor}`,
      },
    },
  };
});
